const languageObj = {
  Confirm: 'إلغاء',
  Cancel: 'إلغاء',
  'The minimum time length is xxxs!': 'الحد الأدنى لطول الوقت هو {{num}}s!',
  'The maximum time length is 50s!': 'أقصى طول للوقت هو 50s!',
  'Online service, no download required': 'الخدمة عبر الإنترنت ، لا يلزم التنزيل',
  'Add up to 20MB file': 'الحد الأقصى لحجم الملف هو 20 ميغا بايت',
  'Support common formats': 'دعم التنسيقات الشائعة',
  'Best for general editing requirements': 'الأفضل لمتطلبات التحرير العامة',
  '0 second wait': '0 ثواني انتظر',
  'No size limits': 'لا حدود للحجم',
  'Support 1000+ formats': 'دعم أكثر من 1000 تنسيق',
  'Stable processing': 'معالجة مستقرة',
  'Get access to HitPaw Toolkit!': 'الوصول إلى HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'يوفر وظائف مثل الاعتراض أو الدوران أو التقليب وتعديل اللون وتغيير السرعة وإضافة الموسيقى وما إلى ذلك.',
  'The easiest video editing software for beginners': 'أسهل برامج تحرير الفيديو للمبتدئين',
  'Remove watermark from videos and images in simple clicks':
    'قم بإزالة العلامة المائية من مقاطع الفيديو والصور بنقرات بسيطة',
  'TRY IT FREE': 'جربها مجانا',
  'BUY NOW': 'اشتري الآن',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'يت والذي لا يمكن تحريره بواسطة موقع HitPaw Online، الرجاء تحميل الفيديو',
  'download the video': ' الرجاء تحميل الفيديو',
  'and then use HitPaw Toolkit to proceed.': ' الرجاء تحميل الفيديو ثم استخدام أدوات HitPaw',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'قص مقاطع فيديو 10 على الأكثر. احصل على HitPaw Toolkit لمزيد من الميزات',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'لا يمكن أن يكون حجم الملف أكبر من 20MB. احصل على HitPaw Toolkit لمزيد من الميزات',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'الحد الأدنى لطول الوقت هو 1s! احصل على HitPaw Toolkit لمزيد من الميزات',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'أضف 3 مقاطع فيديو على الأكثر. احصل على HitPaw Toolkit لمزيد من الميزات',
  'This format is not supported currently.': 'هذا التنسيق غير مدعوم حاليًا.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'هذا التنسيق غير مدعوم حاليًا. احصل على HitPaw Toolkit لمزيد من الميزات',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'فشل إنشاء الفيديو!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'فشل في التحميل!',
  'Are you sure you want to delete it?': 'هل أنت متأكد أنك تريد حذف ذلك؟',
  'Failed to extract the audio!': 'فشل في استخراج الصوت!',
  'Coming Soon': 'قريباً',
  'Learn more': 'تعرف على المزيد',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'أضف ما يصل إلى 2 من الملفات.احصل على HitPaw Toolkit لمزيد من الميزات',
  Download: 'تحميل',
  'Try Again': 'حاول مرة أخرى',
  Failed: 'باءت بالفشل',
  'Get Started': 'البدء',
  Start: 'بداية',
  End: 'نهاية',
  Export: 'يصدر',
  'Your audio is ready!': 'الصوت جاهز!',
  'Download Audio': 'تنزيل الصوت',
  YES: 'نعم',
  'Export Failed': 'فشل التصدير',
  'Error occurs, the file cannot be added': 'حدث خطأ ، لا يمكن إضافة الملف',
  'Support merging audio files at most': 'دعم دمج {{num}} ملفات صوتية على الأكثر',
  'Are you sure you want to delete this task?': 'هل أنت متأكد أنك تريد حذف هذه المهمة؟',
  Processing: 'جارى المعالجة',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'لا تنس تنزيل ملفك ، فسيتم التخلي عنه بعد 24 ساعة.',
  Uploading: 'جاري الرفع',
  'Go Edit': 'ابدأ في التعديل',
  'Generate Files Successfully!': 'إنشاء الملفات بنجاح!',
  'Your order is being paid...': 'يتم دفع طلبك',
  'Not yet': 'ليس بعد',
  'Payment completed': 'نعم',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'الصور المتحركة الخاصة بك جاهزة',
  'Download Without Watermark': 'تحميل بدون علامة مائية',
  'Download As GIF': 'تحميل الصور',
  'Download With Watermark': 'مع العلامة المائية تحميل',
  'Upload New Photo': 'تحميل صور جديدة',
  ////////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'لا يمكن أن يتجاوز حجم الفيديو الذي تم رفعه 20MB. قم بتنزيل برنامج Hitpaw Video Converter',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'لا يمكن أن يتجاوز حجم الفيديو الذي تم تحميله 500MB. قم بتنزيل برنامج Hitpaw Video Converter',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'لا يمكن أن يتجاوز دقة الصورة التي تم رفعها 16 ميجابكسل. قم بتنزيل برنامج HitPaw Video Converter',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'وظيفة معالجة الدفعات متوفرة فقط في برنامج سطح المكتب. قم بتنزيل برنامج HitPaw Video Converter',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'وصل عدد الملفات التي قمت بمعالجتها اليوم إلى الحد الأعلى البالغ 300. قم بتنزيل برنامج HitPaw Video Converter',
  'Download desktop version to batch process large files with no size limit': 'قم بتنزيلبرنامج سطح المكتب لمعالجة ملفات كبيرة بدون حدود',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'دفعة تحويل ملفات الفيديو والصوت إلى 1000+ صيغة بسرعة 120x سرعة أسرع',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'قم بتنزيل وحفظ الفيديو من 10000+ ويب مثل يوتيوب وتيك توك والانستقرام وإلخ.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'ميزات مونتاج الفيديو الغنية المدمجة: دمج وقطع واقتصاص وإضافة علامة مائية وإلخ.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'إزالة DRM من Apple Music وتحويل إلى MP3 بلا خسارة (إصدار Windows فقط)',
}

export default languageObj
